import { createAction, props } from '@ngrx/store';
import { AuditorTask } from '../../models/AuditorTask';
import { AuditorInfo } from "../../models/AuditorInfo";

const TAG = `[Tasks Page]`;

export const initPage = createAction(`${TAG} Init page`);

// Three separate requests, so each part of the page appears as soon as its own answer arrives.
export const loadAssignedTasksSuccess = createAction(`${TAG} Loaded assigned tasks`, props<{ tasks: AuditorTask[] }>());
export const loadAvailableTasksSuccess = createAction(
  `${TAG} Loaded available tasks`,
  props<{ availableTasks: AuditorTask[] }>(),
);
export const loadAuditorStateSuccess = createAction(`${TAG} Loaded auditor state`, props<{ notifyInfo: AuditorInfo }>());
export const loadTasksError = createAction(`${TAG} Error loading tasks`, props<{ error: Error }>());

export const setShouldNotify = createAction(`${TAG} Set Should Notify`, props<{ shouldNotify: boolean }>());
export const setShouldNotifySuccess = createAction(`${TAG} Set Should Notify Success`, props<{ newShouldNotify: boolean }>());
export const setShouldNotifyFailed = createAction(`${TAG} Set Should Notify Failed`, props<{ error: Error }>());

export const setIsAuditorReady = createAction(`${TAG} Set Auditor Ready To Work`, props<{ isAuditorReady: boolean }>());
export const setIsAuditorReadySuccess = createAction(`${TAG} Set Auditor Ready Success`, props<{ newIsAuditorReady: boolean }>());
export const setIsAuditorReadyFailed = createAction(`${TAG} Set Auditor Ready Failed`, props<{ error: Error }>());

export const takeTask = createAction(`${TAG} Take Task`, props<{ task: AuditorTask }>());
export const takeTaskSuccess = createAction(`${TAG} Take Task Success`, props<{ task: AuditorTask; assigneeUsername: string }>());
export const takeTaskFailed = createAction(`${TAG} Take Task Failed`, props<{ error: Error }>());

export const takeAllTasks = createAction(`${TAG} Take All Tasks`, props<{ tasks: AuditorTask[] }>());
export const takeAllTasksSuccess = createAction(`${TAG} Take All Tasks Success`, props<{ tasks: AuditorTask[]; assigneeUsername: string }>());
export const takeAllTasksFailed = createAction(`${TAG} Take All Tasks Failed`, props<{ error: Error }>());

export const giveUpTask = createAction(`${TAG} Give Up Task`, props<{ task: AuditorTask; comment: string }>());
export const giveUpTaskSuccess = createAction(`${TAG} Give Up Task Success`, props<{ task: AuditorTask }>());
export const giveUpTaskFailed = createAction(`${TAG} Give Up Task Failed`, props<{ error: Error }>());

export const loadMoreAvailableTasks = createAction(`${TAG} Load More Available Tasks`);
